// Module
var code = `<div class="option-chain-panel"  {{^.visible}}style="display: none;" {{/}}>
    <div class="option-chain-panel-header">
        <div class="option-chain-panel-header-calls-label">
            {{callsLabel}}
        </div>
        <div class="option-chain-panel-header-combobox">
            <terceraComboBox name="seriesCombobox" showLastValue="true" items="{{seriesComboboxItems}}" selectedItem="{{selectedSerieComboboxItem}}"/>
        </div>
        <div class="option-chain-panel-header-puts-label">
            {{putsLabel}}
        </div>
    </div>
    <div class="option-chain-panel-body">
        <div class="option-chain-panel-body-putcall">
            <quickTableRactive name="callsTable" />
        </div>
        <div class="option-chain-panel-body-strikes">
            <quickTableRactive name="strikesListTable" />
        </div>
        <div class="option-chain-panel-body-putcall">
            <quickTableRactive name="putsTable" />
        </div>
    </div>
</div>`;
// Exports
export default code;